module.exports = __webpack_public_path__ + "img/2_281.d7436d82.png";